import Loadable from 'react-loadable';

const Loading = () => {
    return null;
};

const LivePlayerAsync = Loadable({
    loader: () => import('./livePlayer'),
    loading: Loading,
    delay: 500,
    timeout: 10000,
});

export default LivePlayerAsync;
